const apiURL = "https://foresso-shopify-app.herokuapp.com/api";

const params = new URLSearchParams(window.location.search);
const selectionId = params.has("selection_id")
  ? params.get("selection_id")
  : null;

const getItem = (key) => {
  var data = sessionStorage.getItem(key);

  return key === "shape" || key === "island" ? JSON.parse(data) : data;
};

const setItem = (key, data) => {
  if (data !== null && typeof data === "object") {
    sessionStorage.setItem(key, JSON.stringify(data));
  } else {
    sessionStorage.setItem(key, data);
  }
};

const round = (value, decimals) => {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const formatToAmount = (amount) => {
  return amount ? parseFloat(amount.replace(",", "")) : 0;
};

const formatToCurrency = (amount) => {
  const price = round(amount, 2);
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const animateValue = (obj, start, end, duration) => {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    // obj.innerHTML = Math.floor(progress * (end - start) + start);
    obj.innerHTML = formatToCurrency(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};

const saveSessionData = () => {
  var formData = $("form#worktop_calc").serializeJSON();

  $.each(formData, function (key, data) {
    setItem(key, data);
  });
};

const renderPrice = (total, exclVAT, targetClass) => {
  $(targetClass).text(formatToCurrency(total));
  $(targetClass + "_excl").text(formatToCurrency(exclVAT));

  // sidebar total amount
  let itemsTotal = 0;
  $(".worktop_calculator")
    .find(".item_total")
    .each(function () {
      itemsTotal += formatToAmount($(this).text());
    });
  let itemsexclVATTotal = 0;
  $(".worktop_calculator")
    .find(".item_excl_total")
    .each(function () {
      itemsexclVATTotal += formatToAmount($(this).text());
    });

  const oldTotal = formatToAmount($("#total").text());
  //animateValue(document.getElementById("total"), oldTotal, itemsTotal, 300);
  $("#total").text(formatToCurrency(itemsTotal));

  // summary total amount
  $(".overview_total .worktop_total").text(formatToCurrency(itemsTotal));
  $("#excl_vat_amount").text(formatToCurrency(itemsexclVATTotal));

  if (oldTotal !== itemsTotal) changes = true;

  saveSessionData();
};

const getDimensionValue = (shape, dim, isPlan) => {
  let dimension;
  if (isPlan) {
    dimension = $(
      "#tabs-2 input[name='shape[" + shape + "][" + dim + "]']"
    ).val();
  } else {
    dimension = $("#tabs-4 input[name='island[" + dim + "]']").val();
  }
  return dimension ? dimension / 1000 : 0;
};

const parseFormula = (formulaType, shape, isPlan) => {
  try {
    const shapeData = settings["shapes"][shape];

    let formulaStr;
    if (formulaType === "shape" || formulaType === "thickness") {
      formulaStr = isPlan
        ? shapeData[formulaType + "_formula"]
        : settings["shapes"]["rectangular"][formulaType + "_formula"];
    } else {
      const wallType = isPlan
        ? $('input[name="shape[' + shape + '][wall]"]:checked').data(
            "wall-type"
          )
        : $('input[name="island[wall]"]:checked').data("wall-type");

      formulaStr = isPlan
        ? shapeData[formulaType + "_pricings"][wallType]
        : settings["shapes"]["rectangular"][formulaType + "_pricings"][
            wallType
          ];
    }

    if (formulaStr) {
      if (formulaStr.indexOf("|A|") > -1) {
        const A = getDimensionValue(shape, "A", isPlan);
        formulaStr = formulaStr.replaceAll("|A|", A);
      }

      if (formulaStr.indexOf("|B|") > -1) {
        const B = getDimensionValue(shape, "B", isPlan);
        formulaStr = formulaStr.replaceAll("|B|", B);
      }

      if (formulaStr.indexOf("|C|") > -1) {
        const C = getDimensionValue(shape, "C", isPlan);
        formulaStr = formulaStr.replaceAll("|C|", C);
      }

      if (formulaStr.indexOf("|D|") > -1) {
        const D = getDimensionValue(shape, "D", isPlan);
        formulaStr = formulaStr.replaceAll("|D|", D);
      }

      if (formulaStr.indexOf("|E|") > -1) {
        const E = getDimensionValue(shape, "E", isPlan);
        formulaStr = formulaStr.replaceAll("|E|", E);
      }

      if (formulaStr.indexOf("|F|") > -1) {
        const F = getDimensionValue(shape, "F", isPlan);
        formulaStr = formulaStr.replaceAll("|F|", F);
      }
      //console.log(formulaStr.replaceAll("|", ""));

      return {
        totalFormula: formulaStr.replace(
          "|MATERIAL|",
          settings["material"][material]["price"]
        ),
        exclVatFormula: formulaStr.replace(
          "|MATERIAL|",
          settings["material"][material]["excl_vat"]
        ),
      };
    } else {
      return null;
    }
  } catch (error) {
    alert(error);
    return null;
  }
};

const materialCalculation = () => {
  const shapeFormula = parseFormula("thickness", shape, true);
  console.log("shape :", shape);
  if (shapeFormula) {
    const totalPriceFormula = shapeFormula.totalFormula.replace(
      "|THICKNESS|",
      settings["thickness"][thickness]["price"]
    );
    const totalPrice = eval(totalPriceFormula);

    const exclVatPriceFormula = shapeFormula.exclVatFormula.replace(
      "|THICKNESS|",
      settings["thickness"][thickness]["excl_vat"]
    );
    const exclVatPrice = eval(exclVatPriceFormula);

    renderPrice(totalPrice, exclVatPrice, ".material_amount");
  }

  var thicknessName = $('input[name="thicknessType"]:checked')
    .parent()
    .find(".sub_title .thick_value")
    .text();
  $(".thickness_value").text(thicknessName);
};

const AccessoriesCalculation = () => {
  const acce_item = $('input[name="accessoriesType"]:checked').val();

  if (acce_item == "no-accessoriesType") {
    $(".accessories_name").text("No Accessories selected");
    renderPrice(0, 0, ".accessories_amount");
  } else {
    var aceess_price = settings["accessories"][acce_item]["price"];
    renderPrice(aceess_price, aceess_price, ".accessories_amount");
  }
};

const splashbackCalculation = () => {
  const splashback = $('input[name="splashbackType"]:checked').val();

  if (splashback == "no-splashback") {
    splashbackHeight = 0;
    $('input[name="splashbackHeight"]').val("");
    $('input[name="splashbackHeight"]').attr("disabled", true);
    $("#splash_height").html("No splashback selected");
    $(".splashback_value").parent().parent().hide();

    renderPrice(0, 0, ".splashback_amount");
  } else {
    $('input[name="splashbackHeight"]').attr("disabled", false);

    if (splashbackHeight && splashbackHeight > 0) {
      $("#splash_height").text(splashbackHeight + " mm");
      $(".splashback_value").parent().parent().show();
      
      const splashbackHeightValue = splashbackHeight / 1000;
      
      const shapeFormula = parseFormula("splashback", shape, true);
      if (shapeFormula) {
        const priceExclVAT = eval(
          shapeFormula.exclVatFormula
            .replace("|SPH|", splashbackHeightValue)
            .replace("|MATERIAL|", settings["material"][material]["excl_vat"])
        );

        const totalPrice = eval(
          shapeFormula.totalFormula
            .replace("|SPH|", splashbackHeightValue)
            .replace("|MATERIAL|", settings["material"][material]["price"])
        );
        renderPrice(totalPrice, priceExclVAT, ".splashback_amount");
      } else {
        $("#splash_height").html("Not available");
        renderPrice(0, 0, ".splashback_amount");
      }
    } else if (splashbackHeight <= 0) {
      $("#splash_height").html("Enter splashback height");
    }
  }
  $(".splashback_value").text(splashbackHeight);
};




// Shape functions
const onShapeSelection = () => {

  $("input.ShapeWallType").attr("disabled", false);

  var shapeName = $('input[name="shapeType"]:checked')
    .parent()
    .find(".small_title")
    .text();
  $("#shape_name").html(shapeName);

  var shapeImage = $('input[name="shapeType"]:checked')
    .parent()
    .find("img")
    .attr("src");

  $(".shape_preview_img").attr("src", shapeImage);

  updateDimensions();
};

const updateDimensions = () => {
  $(".selected-dimensions").remove();

  $(".worktop_select_plan ." + shape + "-wrap .amount_details").each(
    function () {
      var side = $(this).find(".input-group-text:first").text();
      var value = $(this).find("input").val();
      $("#invoice_worktop").append(
        '<div class="selected-dimensions"><span>' +
          side +
          ":</span><span>" +
          value +
          " mm</span></div>"
      );
    }
  );
};

const validateDimensions = ($element) => {
  var hasError = 0;

  $element
    .parents(".theme-card-wrap")
    .find("input[type=text]")
    .each(function () {
      var value = $(this).val(),
        shapeType = $(this).data("shape"),
        dimension = $(this).data("dimension");

      if (shapeType && dimension) {
        var minDimension =
          settings["shapes"][shapeType]["min_dimensions"][dimension];

        if (value < minDimension) {
          hasError++;
          $(
            "#tabs-2 .worktop_select_plan ." + shapeType + "-wrap .input-error"
          ).html(
            "<strong>" +
              dimension +
              ":</strong> Minimum " +
              minDimension +
              " mm"
          );
        }
      }
    });

  if (!hasError) {
    console.log(shapeType);
    var shapeType = $element.data("shape");
    $(".worktop_select_plan ." + shapeType + "-wrap .input-error").text("");

    $("input:radio[name=materialType][value='" + material + "']")
      .prop("checked", true)
      .change();
    $("input:radio[name=edgeType][value='" + edge + "']")
      .prop("checked", true)
      .change();
    $("input:radio[name=thicknessType][value='" + thickness + "']")
      .prop("checked", true)
      .change();

    updateDimensions();

    splashbackCalculation();
  }
};

const onSelectWallType = ($element) => {
  shapeWallType = $element.val();

  let wallName = $element.parent().find(".small_title").text();
  $("#wall_name").html(wallName);

  splashbackCalculation();

  $("input:radio[name=edgeType][value='" + edge + "']")
    .prop("checked", true)
    .change();
};

// Island functions
const updateIslandDimensions = () => {
  $("#tabs-5 .island_section #island-dimension-A span:eq(1)").text(
    $("input:text[name='island[A]']").val() + " mm"
  );
  $("#tabs-5 .island_section #island-dimension-B span:eq(1)").text(
    $("input:text[name='island[B]']").val() + " mm"
  );
};

const onSelectIslandWallType = () => {
  var $element = $('input[name="island[wall]"]:checked');
  shapeWallType = $element.val();

  let wallName = $element.parent().find(".small_title").text();
  $(".islandwallsselect").html(wallName);

  if (!shapeWallType) {
    $(".islandwallsselect").html("No wall location selected");
  }

  var islandType = $('input[name="islandType"]:checked').val();
  if (islandType === "no-island") {
    $(".islandwallsselect").html("No island selected");
  }

  //   $("input:radio[name=edgeType][value='" + edge + "']").prop("checked", true).change();
};

const islandCalculation = () => {
  var islandType = $('input[name="islandType"]:checked').val();

  islandPrice = 0;
  islandPriceExclVAT = 0;

  if (islandType != "no-island") {
    const thicknessFormula = parseFormula("thickness", shape, false);
    if (thicknessFormula) {
      const totalPriceFormula = thicknessFormula.totalFormula.replace(
        "|THICKNESS|",
        settings["thickness"][thickness]["price"]
      );
      islandPrice += eval(totalPriceFormula);

      const exclVatPriceFormula = thicknessFormula.exclVatFormula.replace(
        "|THICKNESS|",
        settings["thickness"][thickness]["excl_vat"]
      );
      islandPriceExclVAT += eval(exclVatPriceFormula);
    }

    const edgeFormula = parseFormula("edge", shape, false);
    if (edgeFormula) {
      const totalPriceFormula = edgeFormula.totalFormula.replace(
        "|EDGE|",
        settings["edge"][edge]["price"]
      );
      islandPrice += eval(totalPriceFormula);

      const exclVatPriceFormula = edgeFormula.exclVatFormula.replace(
        "|EDGE|",
        settings["edge"][edge]["excl_vat"]
      );
      islandPriceExclVAT += eval(exclVatPriceFormula);
    }
  }

  renderPrice(islandPrice, islandPriceExclVAT, ".island_amount");

  updateIslandDimensions();

  onSelectIslandWallType();

  islandCutoutCalculation();
};

const validateIslandDimensions = ($element) => {
  var hasError = 0;

  $element
    .parents(".island-wrap")
    .find("input[type=text]")
    .each(function () {
      var value = $(this).val(),
        dimension = $(this).data("dimension");

      if (dimension) {
        var minDimension =
          settings["shapes"]["rectangular"]["min_dimensions"][dimension];

        if (value < minDimension) {
          hasError++;
          $("#tabs-4 .island-wrap .input-error").html(
            "<strong>" +
              dimension +
              ":</strong> Minimum " +
              minDimension +
              " mm"
          );
        }
      }
    });

  if (!hasError) {
    $("#tabs-4 .island-wrap .input-error").text("");

    islandCalculation();
  }
};

// Cut Outs functions
const cutoutCalculation = () => {
  var $qtyTap = $('input[name="tapCutOut"]').val();
  var $qtySink = $('input[name="sinkCutOut"]').val();
  var $qtyHob = $('input[name="hobCutOut"]').val();
  var $qty2Side = $('input[name="2sidedCut"]').val();
  var $qty3Side = $('input[name="3sidedCut"]').val();
  // console.log($qtyTapP);
  if (
    $qtyTap > 0 ||
    $qtySink > 0 ||
    $qtyHob > 0 ||
    $qty2Side > 0 ||
    $qty3Side > 0
  ) {
    $(".pselect").addClass("d-none");
  } else {
    $(".pselect").removeClass("d-none");
  }

  if ($qtyTap > 0) {
    $(".tap").removeClass("d-none");
  } else {
    $(".tap").addClass("d-none");
  }

  if ($qtySink > 0) {
    $(".sink").removeClass("d-none");
  } else {
    $(".sink").addClass("d-none");
  }

  if ($qtyHob > 0) {
    $(".hob").removeClass("d-none");
  } else {
    $(".hob").addClass("d-none");
  }

  if ($qty2Side > 0) {
    $(".2sided").removeClass("d-none");
  } else {
    $(".2sided").addClass("d-none");
  }

  if ($qty3Side > 0) {
    $(".3sided").removeClass("d-none");
  } else {
    $(".3sided").addClass("d-none");
  }

  console.log(settings["tapCutOut"]["price"]);

  // Old code (auto convert to float to inetger)

  /*
  var $qtyTapP = parseInt($qtyTap * settings["tapCutOut"]["price"]);
  var $qtyTapExcl = parseInt($qtyTap * settings["tapCutOut"]["excl_vat"]);
  $('input[name="tapCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtyTapP);
  $(".tap_amount").text($qtyTapP);

  var $qtySinkP = parseInt($qtySink * settings["sinkCutOut"]["price"]);
  var $qtySinkExcl = parseInt($qtySink * settings["sinkCutOut"]["excl_vat"]);
  $('input[name="sinkCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtySinkP);
  $(".sink_amount").text($qtySinkP);

  var $qtyHobP = parseInt($qtyHob * settings["hobCutOut"]["price"]);
  var $qtyHobExcl = parseInt($qtyHob * settings["hobCutOut"]["excl_vat"]);
  $('input[name="hobCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtyHobP);
  $(".hob_amount").text($qtyHobP);

  var $qty2SideP = parseInt($qty2Side * settings["2sidedCut"]["price"]);
  var $qty2SideExcl = parseInt($qty2Side * settings["2sidedCut"]["excl_vat"]);
  $('input[name="2sidedCut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qty2SideP);
  $(".2sided_amount").text($qty2SideP);

  var $qty3SideP = parseInt($qty3Side * settings["3sidedCut"]["price"]);
  var $qty3SideExcl = parseInt($qty3Side * settings["3sidedCut"]["excl_vat"]);
  $('input[name="3sidedCut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qty3SideP);
  $(".3sided_amount").text($qty3SideP); */

  // new code

  // For tapCutOut
  var $qtyTapP = $qtyTap * settings["tapCutOut"]["price"];
  var $qtyTapExcl = $qtyTap * settings["tapCutOut"]["excl_vat"];
  $('input[name="tapCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html(Number.isInteger($qtyTapP) ? $qtyTapP : $qtyTapP.toFixed(2));
  $(".tap_amount").text(
    Number.isInteger($qtyTapP) ? $qtyTapP : $qtyTapP.toFixed(2)
  );

  // For sinkCutOut
  var $qtySinkP = $qtySink * settings["sinkCutOut"]["price"];
  var $qtySinkExcl = $qtySink * settings["sinkCutOut"]["excl_vat"];
  $('input[name="sinkCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html(Number.isInteger($qtySinkP) ? $qtySinkP : $qtySinkP.toFixed(2));
  $(".sink_amount").text(
    Number.isInteger($qtySinkP) ? $qtySinkP : $qtySinkP.toFixed(2)
  );

  // For hobCutOut
  var $qtyHobP = $qtyHob * settings["hobCutOut"]["price"];
  var $qtyHobExcl = $qtyHob * settings["hobCutOut"]["excl_vat"];
  $('input[name="hobCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html(Number.isInteger($qtyHobP) ? $qtyHobP : $qtyHobP.toFixed(2));
  $(".hob_amount").text(
    Number.isInteger($qtyHobP) ? $qtyHobP : $qtyHobP.toFixed(2)
  );

  // For 2sidedCut
  var $qty2SideP = $qty2Side * settings["2sidedCut"]["price"];
  var $qty2SideExcl = $qty2Side * settings["2sidedCut"]["excl_vat"];
  $('input[name="2sidedCut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html(Number.isInteger($qty2SideP) ? $qty2SideP : $qty2SideP.toFixed(2));
  $(".2sided_amount").text(
    Number.isInteger($qty2SideP) ? $qty2SideP : $qty2SideP.toFixed(2)
  );

  // For 3sidedCut
  var $qty3SideP = $qty3Side * settings["3sidedCut"]["price"];
  var $qty3SideExcl = $qty3Side * settings["3sidedCut"]["excl_vat"];
  $('input[name="3sidedCut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html(Number.isInteger($qty3SideP) ? $qty3SideP : $qty3SideP.toFixed(2));
  $(".3sided_amount").text(
    Number.isInteger($qty3SideP) ? $qty3SideP : $qty3SideP.toFixed(2)
  );

  var totalPrice = $qtyTapP + $qtySinkP + $qtyHobP + $qty2SideP + $qty3SideP;
  var priceExclVAT =
    $qtyTapExcl + $qtySinkExcl + $qtyHobExcl + $qty2SideExcl + $qty3SideExcl;
  renderPrice(totalPrice, priceExclVAT, ".cutouts_amount");

  if (totalPrice === 0) {
    $(".cutouts_section").addClass("d-none");
  } else {
    $(".cutouts_section").removeClass("d-none");
  }
};

const islandCutoutCalculation = () => {
  var $qtyTap = $('input[name="islandTapCutOut"]').val();
  var $qtySink = $('input[name="islandSinkCutOut"]').val();
  var $qtyHob = $('input[name="islandHobCutOut"]').val();

  if ($qtyTap > 0 || $qtySink > 0 || $qtyHob > 0) {
    $(".islandpselect").addClass("d-none");
    $(".island_cutouts_section").removeClass("d-none");
  } else {
    $(".islandpselect").removeClass("d-none");
    $(".island_cutouts_section").addClass("d-none");
  }

  if ($qtyTap > 0) {
    $(".islandtap").removeClass("d-none");
  } else {
    $(".islandtap").addClass("d-none");
  }

  if ($qtySink > 0) {
    $(".islandsink").removeClass("d-none");
  } else {
    $(".islandsink").addClass("d-none");
  }

  if ($qtyHob > 0) {
    $(".islandhob").removeClass("d-none");
  } else {
    $(".islandhob").addClass("d-none");
  }

  var $qtyTapP = parseInt($qtyTap * settings["tapCutOut"]["price"]);
  var $qtyTapExcl = parseInt($qtyTap * settings["tapCutOut"]["excl_vat"]);
  $('input[name="tapCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtyTapP);
  $(".tap_amount").text($qtyTapP);

  var $qtySinkP = parseInt($qtySink * settings["sinkCutOut"]["price"]);
  var $qtySinkExcl = parseInt($qtySink * settings["sinkCutOut"]["excl_vat"]);
  $('input[name="islandSinkCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtySinkP);
  $(".islandsink_amount").html($qtySinkP);

  var $qtyHobP = parseInt($qtyHob * settings["hobCutOut"]["price"]);
  var $qtyHobExcl = parseInt($qtyHob * settings["hobCutOut"]["excl_vat"]);
  $('input[name="hobCutOut"]')
    .parent()
    .parent()
    .find(".amount_value")
    .html($qtyHobP);
  $(".hob_amount").text($qtyHobP);

  var totalPrice = islandPrice + $qtyTapP + $qtySinkP + $qtyHobP;
  var priceExclVAT =
    islandPriceExclVAT + $qtyTapExcl + $qtySinkExcl + $qtyHobExcl;
  renderPrice(totalPrice, priceExclVAT, ".island_amount");
};

const setDefaultDimension = () => {
  const shapes = ["rectangular", "L-shape", "U-shape", "irregular"];

  shapes.forEach((s) => {
    $("input:radio[name='shape[" + s + "][wall]'][value='" + s + "_no-walls']")
      .prop("checked", true)
      .change();

    // Set Shape default dimensions
    let defaultDimensions = settings["shapes"][s]["default_dimensions"];
    $.each(defaultDimensions, function (key, value) {
      $(
        ".worktop_select_plan .theme-card-wrap input[name='shape[" +
          s +
          "][" +
          key +
          "]']"
      ).val(value);
    });

    // Set Island default dimensions
    if (s === "rectangular") {
      $("input:text[name='island[A]']").val(
        settings["shapes"]["rectangular"]["default_dimensions"]["A"]
      );
      $("input:text[name='island[B]']").val(
        settings["shapes"]["rectangular"]["default_dimensions"]["B"]
      );
    }
  });
};

const setDefaultData = () => {
  material = "bianco-london-plane";
  edge = "square";
  thickness = "24mm";
  splashback = "no-splashback";
  splashbackHeight = 0;
  shape = "rectangular";
  shapeWallType = "no-walls";
  islandPrice = 0;
  islandPriceExclVAT = 0;
  accessoriesType = "no-accessoriesType";

  // Set material images
  $("#tabs-1 .materials img.material-image").each(function () {
    var materialName = $(this).attr("alt");
    var card = $(this).parent().parent();

    if (settings["material"][materialName]) {
      card
        .find(".small_title")
        .text(settings["material"][materialName]["colour"]);
      card.find(".sub_title").text(settings["material"][materialName]["wood"]);
      card
        .find(".amount_value")
        .text(settings["material"][materialName]["price"]);

      $(this).attr("src", settings["material"][materialName]["image"]);
    }
  });

  // Set Accessories images
  $("#tabs-6 .materials img.material-image").each(function () {
    var materialName = $(this).attr("alt");
    var card = $(this).parent().parent();

    console.log({settings})

    if (settings["accessories"][materialName]) {
      card
        .find(".small_title")
        .text(settings["accessories"][materialName]["name"]);
      card
        .find(".amount_value")
        .text(settings["accessories"][materialName]["price"]);

      $(this).attr("src", settings["accessories"][materialName]["image"]);
    }
  });

  // Set edge images
  $("#tabs-1 img.edge-image").each(function () {
    var edgeName = $(this).attr("alt") + "_edge_image";
    $(this).attr("src", settings["material"][material][edgeName]);
    var card = $(this).parent().parent();
    if (settings['edge'][$(this).attr("alt")]) {
      card
        .find(".amount_value")
        .text(settings["edge"][$(this).attr("alt")]["price"]);
    }
  });

  // Set thickness images
  $("#tabs-1 img.thickness-image").each(function () {
    var thicknessName = $(this).attr("alt") + "_thickness_image";
    $(this).attr("src", settings["material"][material][thicknessName]);

    var card = $(this).parent().parent();

    if (settings['thickness'][$(this).attr("alt")]) {
      card  
        .find(".amount_value")
        .text(settings['thickness'][$(this).attr("alt")]['price']);
    }
    
  });

  setDefaultDimension();

  $("input:radio[name=shapeType][value='" + shape + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=materialType][value='" + material + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=edgeType][value='" + edge + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=thicknessType][value='" + thickness + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=accessoriesType][value='" + accessoriesType + "']")
    .prop("checked", true)
    .change();
};

const setSelectionData = (response) => {
  material = response.materialType;
  edge = response.edgeType;
  thickness = response.thicknessType;
  splashback = "no-splashback";
  splashbackHeight = response.splashbackHeight ? response.splashbackHeight : 0;
  shape = response.shapeType;
  islandPrice = 0;
  islandPriceExclVAT = 0;

  // Styles
  $("input:radio[name=materialType][value='" + material + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=edgeType][value='" + edge + "']")
    .prop("checked", true)
    .change();
  $("input:radio[name=thicknessType][value='" + thickness + "']")
    .prop("checked", true)
    .change();
  if (splashbackHeight > 0) {
    $("input:radio[name='splashbackType'][value='splashback']")
      .prop("checked", true)
      .change();
    $("input:text[name='splashbackHeight']").val(splashbackHeight);
  }

  // Set Shape dimensions
  let shapeDimensions = response["shape"][response.shapeType];
  $.each(shapeDimensions, function (key, value) {
    $(
      ".worktop_select_plan .theme-card-wrap input[name='shape[" +
        shape +
        "][" +
        key +
        "]']"
    ).val(value);
  });
  $("input:radio[name=shapeType][value='" + shape + "']")
    .prop("checked", true)
    .change();

  shapeWallType = response["shape"][response.shapeType]["wall"];
  $(
    "input:radio[name='shape[" +
      shape +
      "][wall]'][value='" +
      shapeWallType +
      "']"
  )
    .prop("checked", true)
    .change();

  // Cut outs
  const cutOuts = [
    "tapCutOut",
    "sinkCutOut",
    "hobCutOut",
    "2sidedCut",
    "3sidedCut",
  ];
  cutOuts.forEach((c) => {
    if (response[c] && response[c] > 0) {
      for (var i = 1; i <= response[c]; i++) {
        $("input[name='" + c + "']")
          .parents(".cut_outs_card")
          .find(".card_icons button.plus_icon_svg")
          .click();
      }
    }
  });

  // Set Island dimensions
  if (response.islandType === "rectangular") {
    $("input:radio[name='islandType'][value='rectangular']")
      .prop("checked", true)
      .change();

    $("input:text[name='island[A]']").val(response["island"]["A"]);
    $("input:text[name='island[B]']").val(response["island"]["B"]);
    $(
      "input:radio[name='island[wall]'][value='" +
        response["island"]["wall"] +
        "']"
    )
      .prop("checked", true)
      .change();

    // Island Cut outs
    const islandCutOuts = [
      "islandTapCutOut",
      "islandSinkCutOut",
      "islandHobCutOut",
    ];
    islandCutOuts.forEach((c) => {
      if (response[c] && response[c] > 0) {
        for (var i = 1; i <= response[c]; i++) {
          $("input[name='" + c + "']")
            .parents(".cut_outs_card")
            .find(".card_icons button.island_plus_icon_svg")
            .click();
        }
      }
    });
  }
};

const getPriceSettings = () => {
  $.ajax({
    type: "GET",
    dataType: "json",
    url: `${apiURL}/settings?surface_type=worktop`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Accept: "application/json",
    },
  })
    .done(function (response) {
      settings = response;
      setDefaultData();
      console.log(settings);

      const params = new URLSearchParams(window.location.search);
      const selectionId = params.has("selection_id")
        ? params.get("selection_id")
        : null;

      if (selectionId && customer_email) {
        $.ajax({
          url: `${apiURL}/getSelection`,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
          data: {
            id: selectionId,
            customerId: customer_id,
          },
        })
          .done(function (response) {
            $("#worktop_loader").css({ opacity: 0, display: "none" });
            setSelectionData(response);
            console.log(response, "dfgg");
          })
          .fail(function (err) {
            $("#worktop_loader").css({ opacity: 0, display: "none" });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Request failed: ${err.statusText}`,
            });
          });
      } else {
        $("#worktop_loader").css({ opacity: 0, display: "none" });
      }
    })
    .fail(function (err) {
      $("#worktop_loader").css({ opacity: 0, display: "none" });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Request failed: ${err.statusText}`,
      });
    });
};

const swalPopup = Swal.mixin({
  backdrop: true,
  showClass: {
    popup: "",
  },
  showCloseButton: true,
  showCancelButton: false,
  showConfirmButton: false,
});

const submitQuote = (title, status) => {
  $("#worktop_loader").css({ opacity: 0, display: "none" });

  swalPopup
    .fire({
      title: title,
      input: "email",
      inputPlaceholder: "Enter your email address",
      inputValue: customer_email,
      inputAttributes: {
        autocapitalize: "off",
      },
      showLoaderOnConfirm: true,
      showConfirmButton: true,
      showCancelButton: () => !Swal.isLoading(),
      showCloseButton: () => !Swal.isLoading(),
      allowOutsideClick: () => !Swal.isLoading(),
      confirmButtonText: "Submit",
      preConfirm: (email) => {
        var formData = $("form#worktop_calc").serializeJSON();
        formData["id"] = selectionId;
        formData["customerId"] = customer_id;
        formData["email"] = email;
        formData["surface_type"] = "worktop";
        formData["final_price"] = $('span#total.worktop_total').text();
        formData["status"] = status; // status: 1 => Request Invoice, 5 => Email me
        
        return fetch(`${apiURL}/submitQuote`, {
          method: "post",
          body: JSON.stringify(formData),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
    })
    .then((result) => {
      if (result.isConfirmed) {
        if (status === 1) {
          var modelBody = `<p class="text-italic">What happens next?</p>
        <p>We will review the details and send you an invoice with a payment link.</p>
        <p>Once it’s paid we’ll send you drawings to confirm and then get it scheduled into production.</p>
        <p class="text-italic">When can I expect delivery?</p>
        <p>Every project is unique so we will confirm an estimated delivery date as soon as possible. In the meantime you can check our Lead Time page for current estimates.</p>`;

          swalPopup
            .fire({
              customClass: {
                container: "placeOrderConfirmation",
              },
              title: "Thank you for your order",
              html: modelBody,
              footer:
                '<div><span class="text-bold">Need some help?</span> <br/> <br/> Check out our <a class="btn-link" href="/pages/faq-contact-us">Help Centre</a>.</div>',
            })
            .then((result) => {
              changes = false;
              if (result.isConfirmed) {
                window.location.href = "/pages/my-worktop-selections";
              }
            });
        }
      }
    });
};

const saveOrBuy = (status) => {
  $("#worktop_loader").css({ opacity: 0.8, display: "flex" });
  
  var accessories_id;

  var formData = $("form#worktop_calc").serializeJSON();
  formData["id"] = selectionId;
  formData["customerId"] = customer_id;
  formData["email"] = customer_email;
  formData["surface_type"] = "worktop";
  formData["final_price"] = $('span#total.worktop_total').text();
  formData["status"] = status;

  if (formData["accessoriesType"] == "maintenance-kit") {
    accessories_id = 41943256531100;
  } else if (formData["accessoriesType"] == "worktop-oil") {
    accessories_id = 41943259349148;
  } else {
    accessories_id = null;
  }

  $.ajax({
    type: "POST",
    data: JSON.stringify(formData),
    dataType: "json",
    url: `${apiURL}/submitQuote`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Accept: "application/json",
    },
  })
    .done(function (result) {
      if (accessories_id != null) {
        var itemsToAdd = [
          { quantity: result.quantity, id: accessories_id },
          { quantity: result.quantity, id: result.variant_id },
        ];
        var requestData = {
          items: itemsToAdd,
        };
      } else {
        var requestData = { quantity: result.quantity, id: result.variant_id };
      }
      if (status === 6) {
        fetch("/cart/add.js", {
          method: "post",
          body: JSON.stringify(requestData),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
        })
          .then((response) => {
            changes = false;
              
            window.location.href = "/cart";
          })
          .catch((error) => {
            swalPopup.fire({
              icon: "error",
              title: "Oops...",
              text: error,
              showConfirmButton: true,
              showCloseButton: false,
            });
          });
      } else {
        $("#worktop_loader").css({ opacity: 0, display: "none" });

        swalPopup
          .fire({
            icon: "success",
            title: "Saved to account!",
            showConfirmButton: true,
            confirmButtonText: "My account",
          })
          .then((result) => {
            changes = false;
            if (result.isConfirmed) {
              window.location.href = "/pages/my-worktop-selections";
            }
          });
      }
    })
    .fail(function (err) {
      $("#worktop_loader").css({ opacity: 0, display: "none" });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Request failed: ${err.statusText}`,
      });
    });
};

//--------------------- IP Configuration -----------------

const ip_configuration = () => {
  $.ajax({
    type: "GET",
    dataType: "json",
    url: `${apiURL}/ipinfo`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Accept: "application/json",
    },
  })
    .done(function (ip_data) {
      console.log(ip_data);
      $("#worktop_loader").css({ opacity: 0, display: "none" });   
      if (
        ip_data["data"]["geoplugin_countryCode"] == "UK" ||
        ip_data["data"]["geoplugin_countryCode"] == "GB"
      ) {
      } else {
        $("#buyNowButton").prop("disabled", true);
        $("#buyNowButton").attr("style", "background:grey;cursor:not-allowed;");
      }
    })
    .fail(function (err) {
      console.log(err);
    });
};
const ip_configuration_custom = () => {
	     $.ajax({
      type: 'GET',
      dataType: "json",
      url: `${apiURL}/ipinfo`,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Accept": "application/json"
      }
    })
    .done(function (ip_data) {
      // console.log(ip_data);
      var country_code = geoplugin_country_code();
      console.log("country_code ::", country_code);
      $("#worktop_loader").css({opacity: 0, display: "none"});
      if(country_code == 'UK' || country_code == 'GB'){}
      else{
        $('#buyNowButton').prop('disabled',true); 
        $('#buyNowButton').attr('style','background:grey;cursor:not-allowed;');
      }
      
    })
    .fail(function (err) {
      console.log(err);
    });
}


// ip_configuration();
setTimeout(() => {
  ip_configuration_custom();
}, 1000);
 
$(document).ready(function () {
  const defaultShape = $("input:radio[name='shapeType'][value='rectangular']");
  
  if (defaultShape.length) {
    defaultShape.prop("checked", true);

    // Wait until your tabs and wall elements exist
    const shape = defaultShape.val();
    setTimeout(function() {
       $(".plan_wall_rectangular input.ShapeWallType").each(function() {
      console.log("this :", this);
      $(this).removeAttr("disabled");
    });
      }, 500); // 500ms delay
   
    // Disable other text inputs safely
    const textInputs = $("#tabs-2 .worktop_select .theme-card-wrap input[type=text]");
    if (textInputs.length) {
      textInputs.attr("disabled", true);
      defaultShape.parents(".theme-card-wrap").find("input[type=text]").attr("disabled", false);
    }

    // Show/hide wall plan cards safely
    const planWalls = $(".plan-walls > .select_card_design.plan_wall_" + shape);
    if (planWalls.length) {
      $(".plan-walls > .select_card_design").addClass("display-none").removeClass("display-flex");
      planWalls.addClass("display-flex").removeClass("display-none");
    }


    // Run your shape selection safely
      onShapeSelection();
      
  }
});